import BaseModalView from "scripts/views/baseModalView";
import { selectedTerms } from "scripts/views/search/facetMapper";
import { chosenAriaLabels } from "scripts/utils/chosenAriaLabels";
import templateFacetedSearchComboBoxMultiSelectModal from "templates/search/facetedSearchComboBoxMultiSelectMenuItem.hbs";

class FacetedSearchComboBoxMultiSelectMenuItemView extends BaseModalView {
  get events() {
    return {
      "click .bb-faceted-search-facet-multiselect-remove-button": "onRemoveTerm",
    };
  }

  get className() {
    return "faceted-search-menu-item";
  }

  get template() {
    return templateFacetedSearchComboBoxMultiSelectModal;
  }

  render() {
    const facetLabel = this.model.get("facetLabel");
    const chosenTermCodes = this.model.get("chosenTermCodes");
    const terms = selectedTerms(
        this.model.get("facetValues"),
        chosenTermCodes,
    );

    this.$el.html(
      this.template({
        facetLabel,
        terms,
      }),
    );

    this.$el
      .find(".selectize-combo")
      .selectize({
        create: false,
        maxItems: 1,
        closeAfterSelect: true,
        highlight: false,
        selectOnTab: false,
        onChange: () => {
            $(".selectize-input input[placeholder]").attr("style", "width: 100%;");
        },
        onItemAdd: value => {
            chosenTermCodes.push(value);
            this.trigger(
                "apply",
                this.model.get("facetParam"),
                chosenTermCodes,
            );
        }
      })
      .each(chosenAriaLabels);

    return this;
  }

    onRemoveTerm(event) {
      const value = event.currentTarget.value;
      const chosenTermCodes = this.model.get("chosenTermCodes");
      const newTermCodes = chosenTermCodes.filter(term => term !== value);

      this.trigger(
          "apply",
          this.model.get("facetParam"),
          newTermCodes,
      );
    }
}

export default FacetedSearchComboBoxMultiSelectMenuItemView;
